import { delay } from "lodash";
import { useEffect, useRef } from "react";


const useTimeoutHandler = (functionCallback: () => void) => {
    const callbackRef: any = useRef(functionCallback);
    const timerId: any = useRef(null);


    useEffect(() => {
        callbackRef.current = functionCallback;
    }, [functionCallback])

    useEffect(() => {

        return () => {
            if (callbackRef.current !== null) {
                removeTimeout();
                callbackRef.current = null;
            }
        }
    }, [])

    const startTimeout = (delay: number) => {
        removeTimeout()
        timerId.current = setTimeout(() => {
            callbackRef.current()
            removeTimeout()
        }, delay)
    }

    const removeTimeout = () => {
        if (timerId.current !== null) {
            clearTimeout(timerId.current)
            timerId.current = null;
        }
    }


    return [startTimeout, removeTimeout];
}

export default useTimeoutHandler;